module.exports = __webpack_public_path__ + "static/wireframesDesktop@2x-dedb3bd1e0a224997c70f3948f0277fa.png";